const isInternalUrl = (url: string) => /^\/(?!\/)/.test(url);

export default isInternalUrl;
